import { render, staticRenderFns } from "./EditHeader.vue?vue&type=template&id=b27f4a3c&"
import script from "./EditHeader.vue?vue&type=script&lang=ts&"
export * from "./EditHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports